<template>
  <div>
    <form class="form-horizontal">
      <fieldset>
        <legend>{{ $t('filter') }}</legend>
        <div class="row">
          <div class="col-md-6">
            <div class="row form-group">
              <label class="col-form-label col-md-5"></label>
              <div class="col-md-5">
                <a-radio-group
                  v-model="acStatusId"
                  size="small"
                  @change="$emit('acStatusChange')"
                >
                  <a-radio-button :value="1">
                    {{ $t('studentScoringEntry.current') }}
                  </a-radio-button>
                  <a-radio-button :value="2">
                    {{ $t('studentScoringEntry.history') }}
                  </a-radio-button>
                </a-radio-group>
              </div>
            </div>
            <div class="row form-group">
              <label class="required col-form-label col-md-5">{{
                $t('studentScoringEntry.className')
              }}</label>
              <div class="col-md-5">
                <a-select
                  v-model="model.class_id"
                  style="width: 150%; height: 35px"
                  :show-search="true"
                  option-filter-prop="children"
                  :filter-option="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  :options="classList"
                  @change="onClassChange"
                ></a-select>
              </div>
            </div>
            <div class="row form-group">
              <label class="required col-form-label col-md-5">{{
                $t('studentScoringEntry.scoringCycle')
              }}</label>
              <div class="col-md-5">
                <a-select
                  style="width: 150%"
                  v-model="model.scoring_cycle_id"
                  @change="scoringCycleChange"
                >
                  <a-select-option
                    v-for="(s, index) in scoringCycle"
                    :key="index"
                    :value="s.scoring_cycle_id"
                  >
                    {{ s.scoring_cycle_name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
            <div class="row form-group" v-if="model.scoring_cycle_id != 4">
              <label class="required col-form-label col-md-5">{{
                $t('studentScoringEntry.scoringCycleValue')
              }}</label>
              <div class="col-md-5">
                <select
                  style="width: 150%"
                  v-model.number="model.cycle_value"
                  v-if="
                    model.scoring_cycle_id == 1 ||
                      model.scoring_cycle_id == 4 ||
                      model.scoring_cycle_id == 5 ||
                      model.scoring_cycle_id == 7
                  "
                  class="form-control"
                >
                  <option :value="null" disabled selected style="display: none">
                    {{ $t('select') }}
                  </option>
                  <option
                    v-for="(s, index) in scoringCycleValues"
                    :key="index"
                    :value="s.scoring_cycle_value"
                  >
                    {{ s.scoring_cycle_description }}
                  </option>
                </select>
                <input
                  v-model.number="model.cycle_value"
                  type="number"
                  style="width: 150%"
                  class="form-control"
                  readonly
                  v-if="
                    model.scoring_cycle_id == 0 ||
                      model.scoring_cycle_id == 2 ||
                      model.scoring_cycle_id == 3
                  "
                />
                <input
                  type="number"
                  class="form-control"
                  style="width: 150%"
                  readonly
                  v-if="model.scoring_cycle_id == null"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row form-group">
              <label class="required col-form-label col-md-5">{{
                $t('studentScoringEntry.mainProgram')
              }}</label>
              <div class="col-md-5">
                <input
                  v-show="acStatusId == 1"
                  type="text"
                  class="form-control"
                  readonly
                  :value="mainProgramLabel"
                />
                <a-select
                  v-show="acStatusId == 2"
                  style="width: 100%"
                  v-model="model.acp_id"
                  @change="onChangeMainProgram"
                >
                  <a-select-option
                    v-for="(main, index) in mainProgramList"
                    :key="index"
                    :value="main.acp_id"
                  >
                    {{ main.acp_name_foreign }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
            <div class="row form-group">
              <label class="required col-form-label col-md-5">{{
                $t('studentScoringEntry.academicYear')
              }}</label>
              <div class="col-md-5">
                <a-select
                  style="width: 100%"
                  v-model="model.ac_year_id"
                  @change="onChangeAcYear"
                  :disabled="acStatusId == 1"
                >
                  <a-select-option
                    v-for="(year, index) in acYearList"
                    :key="index"
                    :value="year.ac_year_id"
                  >
                    {{ year.ac_year }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
            <div class="row form-group">
              <label class="required col-form-label col-md-5">{{
                $t('studentScoringEntry.academicTerm')
              }}</label>
              <div class="col-md-5">
                <input
                  v-show="acStatusId == 1"
                  type="text"
                  class="form-control"
                  readonly
                  :value="acTermLabel"
                />
                <a-select
                  v-show="acStatusId == 2"
                  style="width: 100%"
                  v-model="model.ac_term_id"
                >
                  <a-select-option
                    v-for="(term, index) in acTerms"
                    :key="index"
                    :value="term.ac_term_id"
                  >
                    {{ term.term_name  + (term.ac_status_id == 1 ? ' ( Current ) ' : term.ac_status_id == 2 ? ' ( History ) ' : '( Next )') }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
            <div class="row form-group">
              <label class="col-form-label col-md-5">
                {{ $t('studentScoringEntry.submissionDate') }}
              </label>
              <div class="col-md-5">
                <a-date-picker
                  v-model="model.submission_date"
                  style="width: 100%"
                  placeholder="DD-MM-YYYY"
                  valueFormat="DD-MM-YYYY"
                  format="DD-MM-YYYY"
                  @change="onChangeSubmissionDate"
                />
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </form>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import {
  formViewModel
} from '@/api/student-scoring-table-entry'

export default {
  name: 'filterComponentScoreEntry',
  props: ['value', 'classOperations', 'validate'],
  data() {
    return {
      acYears: [],
      mainPrograms: [],
      acTerms: [],
      model: {},
      term_order: null,
      monthlySemesterMapping: [],
    }
  },
  created() {
    this.model = this.value
    this.fetchAcYear()
    this.fetchMainProgram()
  },
  computed: {
    acYearList() {
      return this.acYears
    },
    mainProgramList() {
      return this.mainPrograms
    },
    scoringCycle() {
      return this.$store.state.studentScoringEntry.scoring_cycles
    },
    scoringCycleValues() {
      if (this.model.scoring_cycle_id) {
        if (this.model.scoring_cycle_id == 7) {
          if (this.term_order == 1) {
            return this.$store.state.studentScoringEntry.scoring_cycle_values
              .filter(s => s.scoring_cycle_id == this.model.scoring_cycle_id)
              .filter(s => _.includes([1, 2], s.scoring_cycle_value)) // Term 1, Term 2 only for semester 1
          }
          return this.$store.state.studentScoringEntry.scoring_cycle_values
            .filter(s => s.scoring_cycle_id == this.model.scoring_cycle_id)
            .filter(s => _.includes([3, 4, 5], s.scoring_cycle_value)) // Term 3, Term 4 and Final Exam only for semester 2
        }
        const { months } = this.monthlySemesterMapping
        if (months) {
          return this.$store.state.studentScoringEntry.scoring_cycle_values.filter(
            s =>
              s.scoring_cycle_id == this.model.scoring_cycle_id &&
              months.includes(s.scoring_cycle_value)
          )
        }
        return this.$store.state.studentScoringEntry.scoring_cycle_values.filter(
          s => s.scoring_cycle_id == this.model.scoring_cycle_id
        )
      }
      return this.$store.state.studentScoringEntry.scoring_cycle_values
    },
    acStatusId: {
      get() {
        return this.$store.state.studentScoringEntry.ac_status_id
      },
      set(newValue) {
        this.$store.commit('studentScoringEntry/SET_AC_STATUS', newValue)
      }
    },
    classList() {
      if(this.acStatusId == 1){
        if (this.model.ac_year_id) {
          return this.classOperations
            .map(el => ({
              value: el.class_id,
              label:
                el.class_name +
                '|' +
                el.teacher.full_name_en +
                '|' +
                el.class_desc +
                '|' +
                el.academic_year.ac_year,
              ac_year_id: el.ac_year_id,
              ac_term_id: el.ac_term_id,
              term_order: el.academic_term.term_order,
              acp_id: el.acp_id,
              acps_id: el.acps_id
            }))
            .filter(el => el.ac_year_id == this.model.ac_year_id)
      }
        return this.classOperations.map(el => ({
          value: el.class_id,
          label:
            el.class_name +
            '|' +
            el.teacher.full_name_en +
            '|' +
            el.class_desc +
            '|' +
            el.academic_year.ac_year,
          ac_year_id: el.ac_year_id,
          ac_term_id: el.ac_term_id,
          term_order: el.academic_term.term_order,
          acp_id: el.acp_id,
          acps_id: el.acps_id
        }))
      }
      if (this.model.ac_term_id) {
        return this.classOperations
          .map(el => ({
            value: el.class_id,
            label:
              el.class_name +
              '|' +
              el.teacher.full_name_en +
              '|' +
              el.class_desc +
              '|' +
              el.academic_year.ac_year,
            ac_year_id: el.ac_year_id,
            ac_term_id: el.ac_term_id,
            term_order: el.academic_term.term_order,
            acp_id: el.acp_id,
            acps_id: el.acps_id
          }))
          .filter(el => el.ac_term_id == this.model.ac_term_id)
          .filter(el => el.ac_year_id == this.model.ac_year_id)
      }
      return this.classOperations.map(el => ({
        value: el.class_id,
        label:
          el.class_name +
          '|' +
          el.teacher.full_name_en +
          '|' +
          el.class_desc +
          '|' +
          el.academic_year.ac_year,
        ac_year_id: el.ac_year_id,
        ac_term_id: el.ac_term_id,
        term_order: el.academic_term.term_order,
        acp_id: el.acp_id,
        acps_id: el.acps_id
      }))
    },
    acYearLabel() {
      return this.classOperations
        .filter(c => c.class_id == this.model.class_id)
        .reduce((init, item) => (init = item.academic_year.ac_year), null)
    },
    mainProgramLabel() {
      return this.classOperations
        .filter(c => c.class_id == this.model.class_id)
        .reduce(
          (init, item) => (init = item.main_program.acp_name_foreign),
          null
        )
    },
    acTermLabel() {
      return this.classOperations
        .filter(c => c.class_id == this.model.class_id)
        .reduce((init, item) => (init = item.academic_term.term_name), null)
    }
  },
  methods: {
    ...mapActions('studentScoringEntry', ['getScoringCycle', 'getAcYear', 'getMainProgram','getTermByMainProgram']),
    async onClassChange(value, option) {
      this.$emit('loading', true)
      this.model.acp_id = option.data.props.acp_id
      this.model.acps_id = option.data.props.acps_id
      this.model.ac_year_id = option.data.props.ac_year_id
      this.model.ac_term_id = option.data.props.ac_term_id
      this.model.scoring_cycle_id = null
      this.model.cycle_value = null
      this.term_order = option.data.props.term_order
      this.monthlySemesterMapping = []
      // await Promise.all([
      //   this.getScoringCycle({ acps_id: option.data.props.acps_id }),
      //   this.fetchSemesterMapping(this.term_order)
      // ])
      const tasks = [
        this.getScoringCycle({ acps_id: option.data.props.acps_id }),
        this.fetchSemesterMapping(this.term_order)
      ]

      if (option.data.props.acp_id && option.data.props.ac_year_id) {
        tasks.push(
          this.getTermByMainProgram({
            ac_year_id: option.data.props.ac_year_id,
            acp_id: option.data.props.acp_id
          })
            .then(response => {
              this.acTerms = response.data
            })
            .catch(error => {
              this.$toasted.error(error.message)
            })
        )
      } else {
        this.acTerms = []
      }

      await Promise.all(tasks)
      this.$emit('loading', false)

    },
    scoringCycleChange() {
      if (
        this.model.scoring_cycle_id == 2 ||
        this.model.scoring_cycle_id == 3 ||
        this.model.scoring_cycle_id == 0
      ) {
        this.model.cycle_value = this.term_order
      } else if (this.model.scoring_cycle_id == 4) {
        this.model.cycle_value = 1
      } else {
        this.model.cycle_value = null
      }
    },
    onChangeSubmissionDate(dateString) {
      this.model.submission_date = dateString
    },
    onChangeAcYear() {
      this.model.class_id = null
      this.model.acps_id = null
      this.model.ac_term_id = null
      this.model.scoring_cycle_id = null
      this.model.cycle_value = null
      this.term_order = null
      this.getTermByMainProgram({
        ac_year_id: this.model.ac_year_id,
        acp_id: this.model.acp_id
      })
        .then(response => {
          this.acTerms = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    onChangeMainProgram() {
      this.model.class_id = null
      this.model.acps_id = null
      this.model.ac_term_id = null
      this.model.ac_year_id = null
      this.model.scoring_cycle_id = null
      this.model.cycle_value = null
      this.term_order = null
    },
    fetchAcYear() {
      this.getAcYear()
        .then(response => {
          this.acYears = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    fetchMainProgram() {
      this.getMainProgram()
        .then(response => {
          this.mainPrograms = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    async fetchSemesterMapping(order) {
      formViewModel({
        params: {
          fnName: 'monthlyForSemester',
          acps_id: this.model.acps_id,
          semester_order: order
        }
      })
        .then((response) => {
          if (response.data.monthlyForSemester) {
            this.monthlySemesterMapping = response.data.monthlyForSemester
          }
        })
    }
  }
}
</script>
